module.exports = __webpack_public_path__ + "img/2018-09-15105940emory.4bdc7634.png";